import React from "react";

function Services() {
  return (
    <div className="services-container">
      <div className="services-title-container">
        <p className="services-title">
          AREAS OF FOCUS<span className="dot">.</span>
        </p>
        <div className="services-desc">
          We specialize in many different areas that when put together, will all
          serve to improve your brands online image.
        </div>
      </div>
      <div className="services-body">
        <div className="row">
          <div className="service">
            <div className="service-title">
              <p className="service-title-txt">WEB DESIGN</p>
            </div>
            <p className="service-desc-txt">
              A quality design is the first crucial step to converting the
              average internet browser, into a paying customer. Each page we
              design is crafted with a purpose.
            </p>
          </div>
          <div className="service">
            <div className="service-title">
              <p className="service-title-txt">WEB DEVELOPMENT</p>
            </div>
            <p className="service-desc-txt">
              We provide full scale web experiences using the latest
              technologies that will produce a unique and high quality website.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="service">
            <div className="service-title">
              <p className="service-title-txt">MAINTENANCE &amp; HOSTING</p>
            </div>
            <p className="service-desc-txt">
              Maintenance and hosting is very important to keep your website
              online, and up to date. We do it so you can spend your time and
              focus where it belongs.
            </p>
          </div>
          <div className="service">
            <div className="service-title">
              <p className="service-title-txt">MONTHLY ANALYTICS REPORTS</p>
            </div>
            <p className="service-desc-txt">
              Monthly reports sent directly to you to keep you in the loop on
              how your site is performing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
